import { defineMessages } from 'react-intl'

export default defineMessages({
  loading: {
    id: 'Loading',
    defaultMessage: 'Loading...'
  }
})
